<script setup lang="ts">
import { Link, useForm } from "@inertiajs/vue3"
import { useNotifications } from "@/composables/useNotifications"

interface CompanyOption {
  id: number
  name: string
}

const props = defineProps<{
  errors?: Record<string, string[]>
  role_keys: string[]
  companies: CompanyOption[]
  selected_company_id?: number
}>()

const form = useForm({
  invitation: {
    company_id: props.selected_company_id ?? props.companies[0]?.id ?? null,
    name: "",
    email: "",
    role_key: "operator",
  },
})

const notify = useNotifications()
const fieldError = (field: string) => props.errors?.[field]?.[0]

function submit() {
  form.post("/backoffice/invitations", {
    onSuccess: () => notify.success("Convite enviado com sucesso"),
  })
}
</script>

<template>
  <main class="mx-auto max-w-3xl px-6 py-10">
    <h1 class="text-2xl font-semibold text-slate-900">Novo convite</h1>
    <p class="mt-2 text-sm text-slate-600">Convide um usuario para uma empresa existente.</p>

    <form class="mt-6 space-y-5 rounded border border-slate-200 bg-white p-6 shadow-sm" @submit.prevent="submit">
      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="company_id">Empresa</label>
        <select id="company_id" v-model="form.invitation.company_id" class="w-full rounded border border-slate-300 px-3 py-2">
          <option v-for="company in props.companies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </select>
        <p v-if="fieldError('company')" class="mt-1 text-sm text-rose-600">{{ fieldError('company') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="name">Nome</label>
        <input id="name" v-model="form.invitation.name" type="text" class="w-full rounded border border-slate-300 px-3 py-2" />
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="email">E-mail</label>
        <input id="email" v-model="form.invitation.email" required type="email" class="w-full rounded border border-slate-300 px-3 py-2" />
        <p v-if="fieldError('email')" class="mt-1 text-sm text-rose-600">{{ fieldError('email') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="role_key">Role</label>
        <select id="role_key" v-model="form.invitation.role_key" class="w-full rounded border border-slate-300 px-3 py-2">
          <option v-for="roleKey in props.role_keys" :key="roleKey" :value="roleKey">
            {{ roleKey }}
          </option>
        </select>
      </div>

      <div class="flex gap-3">
        <button type="submit" :disabled="form.processing" class="rounded bg-indigo-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60">
          Enviar convite
        </button>
        <Link href="/" class="rounded border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700">Voltar</Link>
      </div>
    </form>
  </main>
</template>
